import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3b73ba91"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._iyputc2ruckis4av77ubvklewu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports